import { featureCollection, point } from "@turf/turf";
import { useLiveQuery } from "dexie-react-hooks";
import "maplibre-gl/dist/maplibre-gl.css";
import { useCallback, useRef, useState } from "react";
import MapGl, {
  Layer,
  Source,
  type MapLayerMouseEvent,
  type MapRef,
} from "react-map-gl/maplibre";
import { db } from "../db";

import { useClosest } from "../util/useClosest";

const initialViewState = {
  longitude: -6.25,
  latitude: 53.35,
  zoom: 10,
};

export function HistoryMap() {
  const boxes = useLiveQuery(async () => {
    const boxes = await db.boxes.toArray();

    const points = boxes.map(({ lon, lat, ...props }) =>
      point([lon, lat], props, { id: props.id })
    );

    return featureCollection(points);
  }, []);

  const visited = useLiveQuery(async () => {
    const checkins = await db.checkins.toArray();

    return checkins.map((c) => c.boxId);
  }, []);

  const closest = useClosest(boxes);

  const [selected, setSelected] = useState<string | number>();

  const onMove = useCallback(
    ({ lngLat: { lng, lat } }: MapLayerMouseEvent) => {
      const [feature] = closest(lng, lat, 1);

      setSelected(feature?.id);
    },
    [closest]
  );

  const mapRef = useRef<MapRef>(null);

  return (
    <MapGl
      initialViewState={initialViewState}
      style={{ width: "100%", height: "40vh", borderRadius: "1em" }}
      mapStyle="https://tiles.openfreemap.org/styles/dark"
      onMouseMove={onMove}
      ref={mapRef}
      attributionControl={false}
    >
      {boxes && (
        <>
          <Source type="geojson" data={boxes}>
            <Layer
              type="circle"
              paint={{
                "circle-color": "#fff",
                "circle-opacity": 0.2,
                "circle-radius": 3,
              }}
            ></Layer>

            <Layer
              type="circle"
              paint={{
                "circle-color": "#f08",
                "circle-opacity": 1,
                "circle-radius": 5,
              }}
              filter={["==", ["get", "id"], ["literal", selected || "-1"]]}
            ></Layer>

            <Layer
              type="circle"
              paint={{
                "circle-color": "aquamarine",
                "circle-opacity": 1,
                "circle-radius": 3,
              }}
              filter={["in", ["get", "id"], ["literal", visited || []]]}
            ></Layer>
          </Source>
        </>
      )}
    </MapGl>
  );
}
